import CampaignModel, { CampaignType } from 'cio/models/campaign';

export const DEFAULT_RECIPIENT = '{{customer.channel}}';

export const DEFAULT_RECIPIENT_BY_CAMPAIGN_TYPE: Partial<Record<CampaignType, string>> = {
  [CampaignType.Webhook]: '{{trigger.channel}}',
};

export function getDefaultRecipient(campaign?: CampaignModel) {
  if (campaign == null) {
    return DEFAULT_RECIPIENT;
  }

  return DEFAULT_RECIPIENT_BY_CAMPAIGN_TYPE[campaign.type] ?? DEFAULT_RECIPIENT;
}
